import { render } from "./DocumentScan.vue?vue&type=template&id=7eab88f8&scoped=true"
import script from "./DocumentScan.vue?vue&type=script&lang=js"
export * from "./DocumentScan.vue?vue&type=script&lang=js"

import "./DocumentScan.vue?vue&type=style&index=0&id=7eab88f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eab88f8"]])

export default __exports__